import { CaretDownIcon, CloseIcon } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import { useField } from 'formik'
import { ChangeEvent } from 'react'
import Select, { ClearIndicatorProps, components, DropdownIndicatorProps } from 'react-select'

import { useMobile } from '@/hooks'

import { InputContainer } from '../Input/Input.styles'
import { getDropdownStyles, getOverviewDropdownStyles } from '../InputSelect/InputSelect.util'

export type variant = 'form' | 'clean'

export interface InputMultiSelectProps {
  className?: string
  disabled?: boolean
  id: string
  isClearable?: boolean
  isLoading?: boolean
  label?: string
  name: string
  onChange?: (e: ChangeEvent<any>) => void
  options?: { label?: string; value?: string | number }[]
  variant?: variant
}

export function InputMultiSelect({
  name,
  label,
  id,
  options,
  disabled,
  isLoading,
  className = '',
  isClearable = true,
  onChange,
  variant = 'form',
}: InputMultiSelectProps) {
  const [field, { touched, error }, { setValue, setError }] = useField({ name, type: 'text', id })
  const isError = touched && !!error
  const hint = isError && error

  const { isMobile } = useMobile()

  const handleChange = (value) => {
    setValue(value)
    setError(undefined)
    onChange && onChange(value)
  }

  const dropdownStyles = getDropdownStyles(isError, isClearable, isMobile)
  const cleanDropdownStyles = getOverviewDropdownStyles(isError, isClearable, isMobile)

  const DropdownIndicator = (props: DropdownIndicatorProps<any, true>) => {
    return (
      <components.DropdownIndicator {...props}>
        <CaretDownIcon
          style={{ right: 0, marginRight: 8, top: `${variant == 'form' ? 20 : 12}`, position: 'inherit' }}
        />
      </components.DropdownIndicator>
    )
  }

  const ClearIndicator = (props: ClearIndicatorProps<any, true>) => {
    return (
      <components.ClearIndicator {...props}>
        <CloseIcon
          style={{
            right: 0,
            marginRight: 4,
            top: `${variant == 'form' ? 20 : 12}`,
            position: 'inherit',
            width: 12,
          }}
        />
      </components.ClearIndicator>
    )
  }

  return (
    <SelectContainer className={`flex flex-col ${className}`} isDisabled={disabled} isError={isError}>
      {label && (
        <label className="mb-2 font-medium leading-120 text-primary" htmlFor={id}>
          {label}
        </label>
      )}

      <Select
        components={{ DropdownIndicator: DropdownIndicator, ClearIndicator: ClearIndicator }}
        isLoading={isLoading || false}
        isMulti={true}
        name={field.name}
        onChange={handleChange}
        options={options}
        styles={variant == 'form' ? dropdownStyles : cleanDropdownStyles}
        value={field.value}
      />
      {hint && <p className="mt-1 font-medium text-label-xs text-tertiary">{hint}</p>}
    </SelectContainer>
  )
}

export const SelectContainer = styled(InputContainer)``
